/**
 * Standalone countdown (no imports). Registers <announcement-timer>.
 */
(function () {
  class AnnouncementTimer extends HTMLElement {
    constructor() {
      super();
      /** @type {ReturnType<typeof setInterval> | undefined} */
      this._timerId = undefined;
    }

    connectedCallback() {
      if (this._timerId !== undefined) {
        window.clearInterval(this._timerId);
        this._timerId = undefined;
      }
      this._tick();
      this._timerId = window.setInterval(() => this._tick(), 1000);
    }

    disconnectedCallback() {
      if (this._timerId !== undefined) {
        window.clearInterval(this._timerId);
        this._timerId = undefined;
      }
    }

    _durationSeconds() {
      const fromDataset = Number.parseInt(this.dataset.durationSeconds ?? '', 10);
      const fromAttr = Number.parseInt(this.getAttribute('data-duration-seconds') ?? '', 10);
      const value = Number.isFinite(fromDataset) && fromDataset > 0 ? fromDataset : fromAttr;

      return Number.isFinite(value) && value > 0 ? value : 0;
    }

    _tick() {
      const durationSeconds = this._durationSeconds();
      const timer = this.querySelector('.announcement-bar__timer-value');

      if (!durationSeconds || !timer) return;

      const durationMs = durationSeconds * 1000;
      const remainingMs = durationMs - (Date.now() % durationMs);
      const remainingSeconds = Math.ceil(remainingMs / 1000);

      timer.textContent = this._formatTime(remainingSeconds);
    }

    /**
     * @param {number} totalSeconds
     */
    _formatTime(totalSeconds) {
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      return [hours, minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');
    }
  }

  if (!customElements.get('announcement-timer')) {
    customElements.define('announcement-timer', AnnouncementTimer);
  }
})();
